// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { FeatureFlagOperationsService } from '../generated/api/featureFlagOperations.service';

@Injectable({ providedIn: 'root' })
export class FeatureFlagOperationsClientService {
  constructor(private readonly client: FeatureFlagOperationsService) {}
  // <generated-client-wrappers:methods>
  create(
    request: WrapperApi.FeatureFlagSaveRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('FeatureFlagOperationsService is not available');
    return this.client.featureFlagOperationsCreate(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  delete(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('FeatureFlagOperationsService is not available');
    return this.client.featureFlagOperationsDelete(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  disable(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('FeatureFlagOperationsService is not available');
    return this.client.featureFlagOperationsDisable(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  enable(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('FeatureFlagOperationsService is not available');
    return this.client.featureFlagOperationsEnable(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  evaluate(
    name: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.FeatureFlagEvaluationResult> {
    if (!this.client)
      throw new Error('FeatureFlagOperationsService is not available');
    return this.client.featureFlagOperationsEvaluate(
      name,
      'body',
      reportProgress,
      options,
    );
  }

  get(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.FeatureFlagDetail> {
    if (!this.client)
      throw new Error('FeatureFlagOperationsService is not available');
    return this.client.featureFlagOperationsGet(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  query(
    request: WrapperApi.FeatureFlagQueryRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.FeatureFlagPage> {
    if (!this.client)
      throw new Error('FeatureFlagOperationsService is not available');
    return this.client.featureFlagOperationsQuery(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  update(
    id: string,
    request: WrapperApi.FeatureFlagSaveRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('FeatureFlagOperationsService is not available');
    return this.client.featureFlagOperationsUpdate(
      id,
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
